import React from 'react'
import { Trans } from 'react-i18next'

import { useDebounceInput } from '@/shared/makyo-hooks'
import * as Mime from '@makyoapp/makyo-icon/mimetype'
import { Unknown } from '@makyoapp/makyo-icon/mimetype'
import { Button, SimpleInput, Tabs } from '@makyoapp/makyo-ui'

import { FileManagerKind, useFileManagerContext } from '../../context/FileManagerContext'
import { getMimeIcon } from './MyFilesPanel'

export function FileUrlPanel() {
  const { onChange, onHide, id } = useFileManagerContext()
  //const [value, setValue] = useState('')

  const [debounceInput, cancelDebounceInput, setDebounceInput, value, setValue] = useDebounceInput('')

  const mime = getMimeIcon(debounceInput)
  const Icon = Mime[mime]

  return (
    <Tabs.Panel data-panel-id={FileManagerKind.FileUrl} eventKey={FileManagerKind.FileUrl}>
      <div className='flex-c4'>
        <SimpleInput
          id={id ? `${id}-url` : undefined}
          showClear={Boolean(value)}
          inputClassName='mk-fm-url-input'
          value={value}
          before={Icon ? <Icon width={24} height={24} /> : <Unknown width={24} height={24} />}
          onChange={(e) => {
            setValue(e.currentTarget.value)
          }}
          onClear={() => {
            cancelDebounceInput()
            setDebounceInput('')
            setValue('')
          }}
        />
        <Button
          disabled={!value}
          onClick={() => {
            onChange(FileManagerKind.FileUrl, value)
            setValue('')
            onHide?.()
          }}
        >
          <Trans>Use File</Trans>
        </Button>
      </div>
    </Tabs.Panel>
  )
}
